import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/i18n";
import { AuthShell, inputCls } from "@/pages/Login";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title={t("reset.title")}>
      {done ? (
        <div className="space-y-6" data-testid="reset-done">
          <p className="text-ink-soft">{t("reset.done")}</p>
          <Link to="/login" className="inline-block bg-gold text-void px-6 py-3 hover:bg-gold-hover transition-colors">
            {t("auth.toLogin")}
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <input type="password" required minLength={8} placeholder={t("reset.title")} value={password}
            onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="reset-password" />
          {error && <p className="text-destructive text-sm" data-testid="reset-error">{error}</p>}
          <button type="submit" disabled={loading || !token} data-testid="reset-submit"
            className="w-full bg-gold text-void py-3 font-medium hover:bg-gold-hover transition-colors disabled:opacity-50">
            {loading ? t("common.loading") : t("reset.btn")}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
